import React from 'react';
import Lottie from 'react-lottie';
import asset from '../../assets/chatbot.json';
import './chat.css';

export default function Chat() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: asset,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      }; 
    return (
        <div className="chat__us">
            <a href='https://wa.me/message/JA4RVXU5ELZVH1' > 
                <Lottie
                options={defaultOptions}
                        height={100}
                        width={100}>
                </Lottie>
            </a>

            <div className="chat__popup">

            </div>
        </div>
    )
}
